// // src/services/authService.js
// import axios from 'axios';

// export const loginOwner = async (email, password) => {
//   const response = await axios.post('/api/auth/owner/login', {
//     email,
//     password,
//   });
//   return response.data;
// };

// export const initiateCustomerLogin = async (phoneNumber) => {
//   await axios.post('/api/auth/customer/login', { phoneNumber });
// };

// export const verifyCustomerOTP = async (phoneNumber, otp) => {
//   const response = await axios.post('/api/auth/customer/verify-otp', {
//     phoneNumber,
//     otp,
//   });
//   return response.data;
// };

// // Add to authService.js

// export const verifyToken = async (token) => {
//   try {
//     const response = await axios.get('/api/auth/verify-token', {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     return { valid: false };
//   }
// };

//SOLUTION TWO ==========
import axios from 'axios';

// const API_BASE_URL = 'http://localhost:5000/api';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
// });

// const api = axios.create({
//   baseURL: 'https://twiqli-server-vercel.vercel.app/api',
//   // withCredentials: true,
//   // headers: {
//   //   'Content-Type': 'application/json',
//   // },
// });

const api = axios.create({
  baseURL: 'https://twiqli-server-vercel.vercel.app/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// const API_BASE_URL = 'https://twiqli-job-test-server.vercel.app/api';
export const loginOwner = async (email, password) => {
  try {
    // await api.get(`/restaurants/${restaurantId}/messages`,
    const response = await api.post(`/auth/owner/login`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error(
      'Login error:',
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Owner Login
export const ownerLogin = async (email, password) => {
  const response = await api.post(`/auth/owner-login`, {
    email,
    password,
  });
  return response.data;
};

// Customer Login (OTP Verification)
export const customerLogin = async (phoneNumber) => {
  const response = await api.post(`/auth/customer/login`, {
    phoneNumber,
  });
  return response.data;
};

// Verify OTP
export const verifyOTP = async (phoneNumber, otp) => {
  const response = await api.post(`/auth/verify-otp`, {
    phoneNumber,
    otp,
  });
  return response.data;
};

export const signupOwner = async (name, email, password) => {
  const response = await api.post(`/auth/owner/signup`, {
    name,
    email,
    password,
  });
  return response.data;
};

export const initiateCustomerLogin = async (phoneNumber) => {
  const response = await api.post(`/auth/customer/login`, {
    phoneNumber,
  });
  return response.data;
};

export const verifyCustomerOTP = async (phoneNumber, otp) => {
  const response = await api.post(`/auth/customer/verify-otp`, {
    phoneNumber,
    otp,
  });
  return response.data;
};

// export const verifyToken = async (token) => {
//   const response = await api.get(`${API_BASE_URL}/auth/verify-token`, {
//     headers: { Authorization: `Bearer ${token}` },
//   });
//   return response.data;
// };

// Add to authService.js
export const verifyToken = async (token) => {
  try {
    const response = await api.get(`/auth/verify-token`, {
      headers: {
        Authorization: `Bearer ${token}`, // Correctly set the Authorization header
      },
    });
    return response.data; // Return the whole response data
  } catch (error) {
    return { valid: false };
  }
};

// Forgot Password
export const forgotPassword = async (email) => {
  const response = await api.post(`/auth/forgot-password`, {
    email,
  });
  return response.data;
};

// Reset Password
export const resetPassword = async (token, newPassword) => {
  const response = await api.put(`/auth/reset-password/${token}`, {
    password: newPassword,
  });
  return response.data;
};

export const ownerlogout = () => {
  localStorage.removeItem('ownerToken');
};

export const customerlogout = () => {
  localStorage.removeItem('customerToken');
};

// new here==========
export const ownerSignup = async (name, email, password) => {
  return api.post(`/auth/owner/signup`, {
    name,
    email,
    password,
  });
};

//   export const ownerLogin = async (data) => {
//     return api.post('/auth/owner/login', data);
//   };

export const adminLogin = async (data) => {
  return api.post(`/auth/admin/login`, data);
};

//   export const customerLogin = async (data) => {
//     return api.post('/auth/customer/login', data);
//   };

//   export const verifyCustomerOTP = async (data) => {
//     return api.post('/auth/customer/verify-otp', data);
//   };

export const changePassword = async (data) => {
  return api.post(`/auth/change-password`, data);
};

//   export const forgotPassword = async (data) => {
//     return api.post('/auth/forgot-password', data);
//   };

//   export const resetPassword = async (token, data) => {
//     return api.post(`/auth/reset-password/${token}`, data);
//   };

//   export const verifyToken = async () => {
//     return api.get('/auth/verify-token');
//   };

export const subscribeToRestaurant = async (restaurantId) => {
  const token = localStorage.getItem('customerToken');
  const response = await api.post(
    `/customers/subscribe/${restaurantId}`,
    null,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};
